import { Heading, Text } from '@apollo/orbit';
import { Moon } from '@apollo/space-kit/illustrations/Moon';
import React from 'react';

export const NoAffectedOperations = () => (
  <div className="flex flex-1 flex-col items-center justify-center space-y-3 px-6">
    <Moon className="w-[180px]" />
    <Heading as="h1" size="xl">
      Everything looks good here!
    </Heading>
    <Text variant="subtitle" className="max-w-2xl text-center">
      We found no affected operations in this check.
    </Text>
  </div>
);
